import { onError } from "@apollo/client/link/error";
import redirectToLogin from "./redirectToLogin";
import hasRealmMismatchError from "./hasRealmMismatchError";
import { extractParams } from "@zapier/url-utils";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const errorLink = onError(({ graphQLErrors, networkError, ...rest }) => {
  if (networkError) {
    console.warn(`[Network error]: ${networkError}`);
  }

  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) => {
      console.warn(`[GraphQL error] ${message}`, {
        message,
        locations,
        path,
      });
    });
  }

  if (
    (networkError &&
      "statusCode" in networkError &&
      networkError.statusCode === 401) ||
    (graphQLErrors && graphQLErrors?.[0]?.extensions?.code === 401)
  ) {
    // If we received a 401 the user needs to log in
    redirectToLogin();
  }

  // Check if there was an auth-realm violation (SAML vs regular credentials)
  if (hasRealmMismatchError(graphQLErrors)) {
    if (typeof window !== "undefined") {
      const params = extractParams(window.location.href);

      // We only want to dispatch this route if
      // we aren't already in a reauth flow (otherwise we could
      // potentially trigger this multiple times)
      if (!params.reauth) {
        // There was a violation and the user isn't in the auth flow
        // so force the user to reauthenticate
        redirectToLogin();
      }
    }
  }
});

export default errorLink;
